import React from "react";
import MealItem from "./../../molecules/MealItem";
import styled from "styled-components";

const Wrap = styled.div`
  margin: 0 -24px;
  padding: 16px 24px;

  @media (min-width: 990px) {
    margin: 0;
    padding: 16px;
    padding-top: 25px;
  }
`;

const SectionWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;

  .meal-controls {
    display: none;
  }

  .meal-item {
    @media (min-width: 990px) {
      width: 16.66%;

      &:nth-child(3n + 4) {
        &::before {
          display: none;
        }
      }

      &:nth-child(6n + 7) {
        &::before {
          display: block;
          content: "";
          position: absolute;
          width: calc(100% - 15px);
          border-top: 1px solid #e6e6e6;
          transform: translate(0, -10px);
        }
      }
    }
  }
`;

function DeliveryMealList(props) {
  const { meals } = props;

  return (
    <>
      <Wrap className="delivery-item__meal-list">
        <SectionWrap>
          {meals.length > 0 &&
            meals.map((meal) => {
              if (meal.quantity > 0) {
                return (
                  <MealItem
                    key={meal.id}
                    {...meal}
                    quantitySelected={meal.quantity}
                    showQuantityBadge={true}
                    excluded={false}
                    view={"compact"}
                    deliveryItem={true}
                  />
                );
              } else {
                return null;
              }
            })}
        </SectionWrap>
      </Wrap>
    </>
  );
}

export default DeliveryMealList;
